import { render, staticRenderFns } from "./challengingordermanagementbottom.vue?vue&type=template&id=a276b086&scoped=true&"
import script from "./challengingordermanagementbottom.vue?vue&type=script&lang=js&"
export * from "./challengingordermanagementbottom.vue?vue&type=script&lang=js&"
import style0 from "./challengingordermanagementbottom.vue?vue&type=style&index=0&id=a276b086&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a276b086",
  null
  
)

export default component.exports